import InputNumber from 'antd/es/input-number';

export default InputNumber;
